import Image from 'next/image';
import style from '~/components/about-page/style.module.css';
import Container from '../common/container';
import { useState } from 'react';
import { Translate } from '~/i18n';
import visionImage from '~/public/images/about-page/saudi-vision-2030.jpg';

/******************************************************************
 *
 *  THIS COMPONENT WAS GENERATED BY NEXTCRAZY-CLI
 *
 ******************************************************************/

const Vision = () => {
   const [openImage, setOpenImage] = useState(false);
   return (
      <Container className="flex-col">
         <div className={`flex lg:flex-row flex-col lg:rtl:flex-row-reverse ${style['vision']}`}>
            {!openImage ? (
               <div
                  onClick={() => setOpenImage(p => !p)}
                  className={`lg:w-1/2 lg:h-96 xs:h-80 h-52 cursor-pointer border border-primary-disabled ${style['perspective']} `}>
                  <Image
                     src={visionImage}
                     layout="fill"
                     placeholder="blur"
                     className="object-cover"
                  />
               </div>
            ) : (
               <div
                  onClick={() => setOpenImage(p => !p)}
                  className={`lg:w-1/2 lg:h-96 xs:h-80 h-52 cursor-pointer border border-primary-disabled ${style['perspective-active']} `}>
                  <Image src={visionImage} layout="fill" className="object-cover" />
               </div>
            )}
            <div className="lg:w-1/2 pt-14 lg:p-14">
               <h2 className="text-4xl font-bold">
                  <Translate id="about:our vision" />
               </h2>
               <p className="py-4 text-xl ">
                  <Translate id="about:be ultimate platform" />
               </p>
            </div>
         </div>
         <div
            onClick={() => setOpenImage(p => !p)}
            className="hidden pt-5 text-gray-400 cursor-pointer xl:inline-block ltr:tracking-widest rtl:text-left">
            <Translate id="about:click to zoom" />
         </div>
      </Container>
   );
};

export default Vision;
